import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Table } from 'libs.nucleus';
import { useDateTime } from 'libs.react';
import { UserIcon } from '../../svgIcons/user.icon';
import { usePIOversightDetailsTableColumns } from '../hooks/pi_oversight_details_table_columns.hook';
const ActivityTaskResponses = ({ responses }) => {
    const { parseDateTimeShort } = useDateTime();
    const { taskResponsesTableColumns } = usePIOversightDetailsTableColumns();
    if (responses.length === 0) {
        return null;
    }
    return (_jsx("div", { "data-testid": 'responses-section', children: responses.map((response) => {
            // matches step order sorting on the response detail view in responses tab
            const sortedResponses = response.responses.sort((a, b) => a.order - b.order);
            return (_jsxs("div", { className: 'border-b border-gray-300 pb-8 mb-8 last:border-b-0 last:mb-0', "data-testid": 'task-response', children: [_jsxs("div", { className: 'flex items-center gap-1 mb-2', children: [_jsx(UserIcon, { height: 16, width: 16, className: 'text-purple-500' }), _jsx("span", { className: 'text-sm text-text-secondary', children: parseDateTimeShort(response.taskResponseCompletedDate) })] }), _jsx("p", { className: 'text-lg font-semibold mb-8', children: response.activity }), _jsx(Table, { columns: taskResponsesTableColumns, data: sortedResponses, labelNoResults: '', hasPagination: false, getRowId: (row) => row.stepResponseId })] }, response.taskResponseId));
        }) }));
};
export default ActivityTaskResponses;
